module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dnnCloud-sys-box"
  }, [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": _vm.activeIndex,
      "mode": "horizontal"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_vm._v("轮播图")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2"
    }
  }, [_vm._v("系统参数")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLBT),
      expression: "showLBT"
    }],
    staticClass: "sys-tab-item"
  }, [_c('UrlsLBT')], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showURL),
      expression: "showURL"
    }],
    staticClass: "sys-tab-item"
  }, [_c('UrlsNumber')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bc96483"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/administrator/urls/Urls.vue
// module id = 1747
// module chunks = 9